package app.api

import app.client
import app.model.PaginatedResponse
import app.model.ProjectRelease
import app.plugin.Routing
import dev.fritz2.core.RootStore
import io.ktor.client.call.*
import io.ktor.client.plugins.resources.*
import io.ktor.client.request.*
import io.ktor.http.*
import kotlinx.coroutines.Job
import kotlinx.serialization.encodeToString
import kotlinx.serialization.json.Json

class ProjectReleasesPaginatedApi : RootStore<PaginatedResponse<ProjectRelease>>(
    PaginatedResponse(emptyList(), 0, 0, 0, 10),
    job = Job()
) {
    data class PaginationRequest(
        val projectId: String,
        val sort: String,
        val order: String,
        val page: Int,
        val pageSize: Int = 10
    )

    val handler = handle { _, req: PaginationRequest ->
        val projectId = req.projectId.toInt()
        client.get(
            Routing.ProjectReleases.Sort(
                projectId = projectId,
                sort = req.sort,
                order = req.order,
                page = req.page,
                size = req.pageSize,
            )
        ).body<PaginatedResponse<ProjectRelease>>()
    }

    val deleteProjectRelease = handle { state, id: Int ->
        val resp = client.delete(Routing.ProjectReleases.Id(id = id))
        require(resp.status == HttpStatusCode.NoContent)
        state.copy(items = state.items.filter { it.id != id })
    }

    val newProjectRelease = handle { state, request: Routing.ProjectReleases.New.Body ->
        val newRelease = client.post(
            Routing.ProjectReleases.New()
        ) {
            contentType(ContentType.Application.Json)
            setBody(Json.encodeToString(request))
        }.body<ProjectRelease>()
        state.copy(items = listOf(newRelease) + state.items)
    }
}
